import LockIcon from '@mui/icons-material/Lock';
import NavBtn from '@mui/icons-material/Menu';
import ChatIcon from '@mui/icons-material/Chat';
import EmailIcon from '@mui/icons-material/Email';
import Person2Icon from '@mui/icons-material/Person2';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EditIcon from '@mui/icons-material/Edit';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FlagIcon from '@mui/icons-material/Flag';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import menuImg from '../assets/menu.png';
import pinImg from '../assets/pin.png';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import SendIcon from '@mui/icons-material/Send';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { Delete, Settings } from '@mui/icons-material';

export const IMAGES = {
  logo: 'https://firebasestorage.googleapis.com/v0/b/yigit-c81f1.appspot.com/o/crm%2Ffavicon.ico?alt=media&token=b42516be-30bf-4ef3-9961-87307e9ad8a7',
};

export const ICONS = {
  delete: <Delete />,
  NavBtn: <NavBtn />,
  email: <EmailIcon />,
  password: <LockIcon />,
  visible: <VisibilityIcon />,
  hide: <VisibilityOffIcon />,
  menu: <img src={menuImg} alt="Menu" />,
  pinImage: <img src={pinImg} alt="Pin" width={20} />,
  user: <Person2Icon />,
  chat: <ChatIcon />,
  privacy: <SafetyCheckIcon />,
  eye: <RemoveRedEyeIcon />,
  pin: <LocationOnIcon />,
  phone: <LocalPhoneIcon />,
  edit: <EditIcon />,
  status: <CrisisAlertIcon />,
  based: <FlagIcon />,
  van: <AirportShuttleIcon />,
  setting: <Settings />,
  driver: <DriveEtaIcon />,
  notes: <SpeakerNotesIcon />,
  send: <SendIcon />,
  down: <ArrowDropDownIcon />,
  right: <ArrowRightIcon />,
  booking: <BookmarkBorderIcon />,
  expandMoreIcon: <ExpandMoreIcon sx={{ color: 'white' }} />,
};
